import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 12h-14","key":"svg-0"}],["path",{"d":"M6 9l-3 3l3 3","key":"svg-1"}],["path",{"d":"M21 14h-4v-4h4z","key":"svg-2"}]]

const IconArrowLeftSquare = createReactComponent('outline', 'arrow-left-square', 'ArrowLeftSquare', __iconNode);

export default IconArrowLeftSquare;